
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.574 4.282h14.724v12.783c0 2.495-2.154 4.522-4.805 4.535H6.392c-2.651 0-4.805-2.027-4.818-4.535V4.282zM15.22 5.296H2.664v11.769c0 1.938 1.669 3.496 3.728 3.509h5.1c2.06 0 3.715-1.57 3.729-3.51V5.297z","fill":"#333"}}),_c('path',{attrs:{"d":"M16.123 1.734h.135c1.036.076 1.817.938 1.736 1.913-.08.95-.955 1.673-1.965 1.635H1.884C.848 5.282 0 4.483 0 3.508c0-.976.848-1.774 1.884-1.774h14.239zm0 2.534c.445 0 .808-.355.794-.773 0-.392-.322-.71-.74-.747H1.857c-.444 0-.807.33-.807.747 0 .418.35.76.794.76h.013l14.267.013z","fill":"#333"}}),_c('path',{attrs:{"d":"M12.246 2.762H5.625l-.135-.317C5.1 1.533 5.571.495 6.54.127 6.755.038 6.998 0 7.24 0h3.392c1.05 0 1.884.798 1.884 1.786 0 .228-.04.444-.135.659l-.135.317zm-5.8-1.014h4.993c-.013-.405-.377-.722-.807-.722H7.24c-.43 0-.78.317-.794.722zM5.637 18.137c-.297 0-.539-.229-.539-.507V7.444c0-.278.242-.506.539-.506.296 0 .538.228.538.506V17.63c0 .279-.242.507-.538.507zM8.947 18.137c-.296 0-.538-.229-.538-.507V7.444c0-.278.242-.506.538-.506.296 0 .539.228.539.506V17.63c0 .279-.243.507-.539.507zM12.258 18.137c-.296 0-.538-.229-.538-.507V7.444c0-.278.242-.506.538-.506.296 0 .538.228.538.506V17.63c0 .279-.242.507-.538.507z","fill":"#333"}})])
          )
        }
      }
    